import { ComponentAuthorizationService } from '@adesa/authorization';
import { Component } from '@angular/core';

@Component({
  selector: 'shell-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(componentAuthorization: ComponentAuthorizationService) {
    componentAuthorization.enable();
  }
}
